import { CHAINS } from './chains'

const EVM_HASH_RE = /0x[0-9a-fA-F]{64}/
const SVM_SIG_RE = /[1-9A-HJ-NP-Za-km-z]{87,88}/
const SOLANA_DOMAIN = 5

let hostMap: Map<string, number> | null = null
function buildHostMap() {
  const m = new Map<string, number>()
  for (const c of Object.values(CHAINS)) {
    if (!c.txUrl) continue
    try {
      const host = new URL(c.txUrl).hostname.replace(/^www\./, '')
      m.set(host, c.domain)
    } catch {}
  }
  return m
}

function domainFromUrl(input: string): number | undefined {
  if (!hostMap) hostMap = buildHostMap()
  try {
    const url = new URL(input)
    const host = url.hostname.replace(/^www\./, '')
    return hostMap.get(host)
  } catch {
    return undefined
  }
}

export type ParsedTx = { tx: string; domain?: number }

export function parseTxInput(input: string): ParsedTx | null {
  const trimmed = input.trim()
  if (!trimmed) return null
  const urlDomain = domainFromUrl(trimmed)

  const evm = trimmed.match(EVM_HASH_RE)
  if (evm) {
    const tx = evm[0].toLowerCase()
    return urlDomain != null ? { tx, domain: urlDomain } : { tx }
  }

  const svm = trimmed.match(SVM_SIG_RE)
  if (svm) {
    return { tx: svm[0], domain: urlDomain ?? SOLANA_DOMAIN }
  }

  return null
}
